import { Component, OnInit, TemplateRef, ViewChild, Inject, ViewEncapsulation } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AppComponent } from 'src/app/app.component';
import { Parcela, Paginacao, ParcelaPaginado, LoteHonorario, RequestLoteHonorarioType } from 'src/app/shared/services/acordo-ressarcimento/api/models';
import { LoadingService } from 'src/app/shared/services/components/loading.service';
import { ParcelaService, LoteHonorarioService, UsuarioService } from 'src/app/shared/services/acordo-ressarcimento/api/services';
import { ConsultarLoteHonorarioService } from '../pagamento-honorario.service';
import { Location } from '@angular/common';
import { PsModalLoadingComponent } from 'porto-seguro-guide';
import { FormGroup, FormBuilder } from '@angular/forms';

@Component({
  selector: 'app-detalhe-honorario',
  templateUrl: './detalhe-honorario.component.html',
  styleUrls: ['./detalhe-honorario.component.css'],
  encapsulation: ViewEncapsulation.None
})
export class DetalheHonorarioComponent implements OnInit {

  public numeroLoteHonorario: number;
  public loadingLista = false;
  source = [];
  columnsTemplate = [];
  public lote: LoteHonorario;
  public formLote: FormGroup;
  public flagReprovarHonorario: boolean;
  public flagAprovarHonorario: boolean;
  public flagAjusteManual: boolean = JSON.parse(sessionStorage.getItem('flagAjusteManual'));
  public page: Paginacao;
  public numeroLote;
  public parcelaAtualizar: Parcela;

  @ViewChild('templateMarca') private templateMarca: TemplateRef<any>;
  @ViewChild('templateVencimento') private templateVencimento: TemplateRef<any>;
  @ViewChild('templateValorParcela') private templateValorParcela: TemplateRef<any>;
  @ViewChild('templateJuros') private templateJuros: TemplateRef<any>;
  @ViewChild('templateHonorario') private templateHonorario: TemplateRef<any>;
  @ViewChild('templateDataPagamento') private templateDataPagamento: TemplateRef<any>;
  @ViewChild('templateDataBaixa') private templateDataBaixa: TemplateRef<any>;
  @ViewChild('ModalAprovadoLote') modalAprovadoLote: PsModalLoadingComponent;
  @ViewChild('ModalVoltadoStatus') modalVoltadoStatus: PsModalLoadingComponent;
  @ViewChild('ModalReprovadoLote') modalReprovadoLote: PsModalLoadingComponent;
  @ViewChild('templateLote') private templateLote: TemplateRef<any>;
  @ViewChild('ModalConcluidoLote') modalConcluidoLote: PsModalLoadingComponent;

  constructor(
    private route: ActivatedRoute,
    public parcelaService: ParcelaService,
    public loteHonorarioService: LoteHonorarioService,
    public consultarLoteHonorarioService: ConsultarLoteHonorarioService,
    private loading: LoadingService,
    private router: Router,
    private location: Location,
    private formBuilder: FormBuilder,
    public usuarioService: UsuarioService,
    @Inject(AppComponent) public appComponent: AppComponent) { }

  public ngOnInit() {
    this.columnsTemplate = [
      { prop: 'acordo.nomeEscritorio', label: 'Escritório' },
      { prop: 'acordo.processoRessarcimento.codigoRamoSinistro', label: 'Ramo' },
      { prop: 'acordo.processoRessarcimento.numeroSinistro', label: 'Sinistro' },
      { prop: 'acordo.processoRessarcimento.anoSinistro', label: 'Ano' },
      { prop: 'acordo.processoRessarcimento.sequenciaItemSinistro', label: 'Item' },
      { prop: 'numeroParcela', label: 'N° Parcelas' },
      { label: 'Data de vencimento', template: this.templateVencimento },
      { prop: 'tipoSituacaoParcelaAcordo.nomeTipoSituacaoParcelaAcordo', label: 'Status da Parcelas' },
      { label: 'Valor da Parcela', template: this.templateValorParcela },
      { label: 'Juros', template: this.templateJuros },
      { label: 'Honorario', template: this.templateHonorario },
      { label: 'Data do pagamento', template: this.templateDataPagamento },
      { label: 'Data da baixa', template: this.templateDataBaixa },
      { label: 'Marca', template: this.templateMarca },
      { label: 'Atualizar Lote', template: this.templateLote },
    ];

    this.numeroLoteHonorario = this.route.snapshot.params['numeroLoteHonorario'];
    this.criarFormLote();

    this.carregarDadosPagina();

    this.recuperarDadosLoteHonorario(undefined);
  }

  public carregarDadosPagina() {
    this.usuarioService.recuperarDadosUsuario().subscribe(result => {

        this.flagReprovarHonorario = result.flagReprovaHonorario;
        this.flagAprovarHonorario = result.flagAprovaHonorario;
        this.flagAjusteManual = result.flagAjusteManual;

        /*
        if( result.codigoEscritorio ) {
            this.codigoEscritorio = result.codigoEscritorio;
        }

        if( result.nomeEscritorio ) {
            this.nomeEscritorio = result.nomeEscritorio;
        }

        this.isEscritorio = result.flagEscritorio;
        */
    });
  }

  private criarFormLote() {
    this.formLote = this.formBuilder.group({
      textoJustificativaReprovacao: null
    });
  }

  public recuperarDadosLoteHonorario(page) {
    this.loading.open();

    var parametros: LoteHonorarioService.ObterLotePaginadoPorNumeroParams = {
      numeroLote: this.numeroLoteHonorario,
      page: page == undefined ? 0 : page,
      perPage: 10
    }

    this.loteHonorarioService.obterLotePaginadoPorNumero(parametros).subscribe(response => {
      this.lote = response;
      if (response.parcelaPaginado.parcelas != undefined) {
        this.page = response.parcelaPaginado.paginacao;
        this.source = response.parcelaPaginado.parcelas;
      }
      this.loading.close();
    }, error => {
      this.appComponent.createAlert("Erro ao efetivar consulta!", 'error');
    });
  }

  public voltar() {
    setTimeout(() => {
      this.consultarLoteHonorarioService.setRealizaPesquisa(true);
      this.location.back();
    }, 500);
  }

  public reprovarLote(numeroLote: number, ModalReprovar) {

    if (this.formLote.value['textoJustificativaReprovacao'] == null || this.formLote.value['textoJustificativaReprovacao'] == '') {
      this.appComponent.createAlert("É necessário informar uma justificativa!", 'error');
      return;
    } else {
      ModalReprovar.close();
      this.loading.open();

      var parametros: RequestLoteHonorarioType = {
        numeroLote: numeroLote,
        textoJustificativaReprovacao: this.formLote.value['textoJustificativaReprovacao']
      }

      this.loteHonorarioService.reprovarLote(parametros).subscribe(response => {
        this.loading.close();
        this.modalReprovadoLote.open(null);
      }, error => {
        this.loading.close();
        this.loadingLista = false;
        this.appComponent.createAlert("Erro ao efetivar consulta!", 'error');
      });
    }
  }

  public aprovarLote(numeroLote: number, ModalAprovar) {
    ModalAprovar.close();
    this.loading.open();

    var parametros: RequestLoteHonorarioType = {
      numeroLote: numeroLote
    }

    this.loteHonorarioService.aprovarLote(parametros).subscribe(response => {
      this.loading.close();
      this.modalAprovadoLote.open(null);
    }, error => {
      this.loading.close();
      this.loadingLista = false;
      this.appComponent.createAlert("Erro ao efetivar consulta!", 'error');
    });
  }

  public voltaStatus(numeroLote: number, ModalvoltaStatus) {
    ModalvoltaStatus.close();
    this.loading.open();

    var parametros: RequestLoteHonorarioType = {
      numeroLote: numeroLote
    }

    this.loteHonorarioService.voltaStatus(parametros).subscribe(response => {
      this.loading.close();
      this.modalVoltadoStatus.open(null);
    }, error => {
      this.loading.close();
      this.loadingLista = false;
      this.appComponent.createAlert("Erro ao voltar status do lote!", 'error');
    });
  }

  public paginar(evt) {
    this.recuperarDadosLoteHonorario(evt.offset);
  }

  public atualizarLote(ModalAtualizaLote, ModalGravando) {
    if (this.numeroLote === undefined || this.numeroLote === null) {
        this.appComponent.createAlert("Número do Lote obrigatório!", 'error');
        return;
    }

    ModalAtualizaLote.close();
    ModalGravando.open();

    const param: Parcela = {
      codigoParcela: this.parcelaAtualizar.codigoParcela,
      numeroLoteHonorario: {
        numeroLote: this.numeroLote
      }
    };

    this.parcelaService.atualizarLoteParcela(param).subscribe(data => {
      ModalGravando.close();
      this.appComponent.createAlert('Lote atualizado com sucesso!.', 'success');
    }, message => {
      ModalGravando.close();
      if (message.includes('404')) {
        this.appComponent.createAlert('Lote informado não existe', 'error');
      } else {
        this.appComponent.createAlert('Ocorreu um erro ao atualizar o Lote da Parcela', 'error');
      }
    });

    this.numeroLote = undefined;
  }

}
